module.exports = __webpack_public_path__ + "img/img (10).68be8d06.png";